/**
 * @desc getCabinInfo
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.CabinMasterDataResponseDto>;
export function request(
  params: API.tms.cabinMasterFacadeImpl.getCabinInfo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMaster/getCabinInfo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
